'use strict';

// modules
var hamburgerMenu = require('./_modules/hamburgerMenu');
var smoothScroll = require('./_modules/smoothScroll');
var eqHeight = require('./_modules/eqHeight');
var videoEqheight = require('./_modules/videoEqheight');
var pageTop = require('./_modules/pageTop');
var topPage = require('./_modules/topPage1');
var mainVis = require('./_modules/mainVis');
var newsTicker = require('./_modules/newsTicker');
var youTube = require('./_modules/youTube');
var playVideo = require('./_modules/video');
var fileUpload = require('./_modules/upload');
var slickSlider = require('./_modules/slider');

// functions
// - common
var hamburgermenu = new HamburgerMenu($('.js-hamburger'));

$('.js-height').each(function(){
  var eqheight = new EqHeight(this);
});

$('.p-campaign-pickup-items.mod-list').each(function(){
  var videoEqheight = new videoEqHeight(this);
});

$('.js-scroll').each(function(){
  var smoothscroll = new Smoothscroll(this);
});

$('.js-pagetop').each(function(){
  var pagetop = new PageTop(this);
});

$('.js-mv').each(function(){
  var mainvis = new MainVis(this);
});

$('.js-news').each(function(){
  var newsticker = new NewsTicker(this);
});

$('.js-upload').each(function(){
  var fileupload = new Upload(this);
});

$('.js-youtube').each(function(){
  var youtube = new YouTube(this);
});

$('.js-video').each(function(){
  var playvideo = new Video(this);
});

$('.js-slider').each(function(){
  var slider = new Slider(this);
});

// - top page
if($('.p-top').length){
  var toppage = new TopPage();
}

$(function(){
     $('.image-hover a img').hover(function(){
        $(this).attr('src', $(this).attr('src').replace('_off', '_on'));
          }, function(){
             $(this).attr('src', $(this).attr('src').replace('_on', '_off'));
   });
});


//////////////////
// WEBPACK FOOTER
// ./js/common.js
// module id = 0
// module chunks = 0